import React from 'react';

import { ApplyButton } from 'components/Filters';

import { useScreenState } from '@gogame/screens';

const ApplyFiltersButton = ({ tooltip, onClick, dirty }) => {
  const screenState = useScreenState();

  const filtersDirty = !screenState.ready || !!screenState.temporary;

  return (
    <ApplyButton
      tooltip={tooltip}
      onClick={onClick}
      disabled={!(filtersDirty || dirty)}
    />
  );
};

export default ApplyFiltersButton;
